(() => {
  'use strict';

  const MAX_FINGERPRINTS = 8;
  const fingerprints = new Set();
  const scripts = new Set();
  const errorNames = new Set();
  const errorKinds = new Set();
  let eventSent = false;

  function hash32(value) {
    let hash = 2166136261;
    for (let index = 0; index < value.length; index += 1) {
      hash ^= value.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(16).padStart(8, '0');
  }

  function scriptName(value) {
    try {
      const path = new URL(value || '', location.href).pathname;
      return path.split('/').filter(Boolean).pop() || 'inline';
    } catch (_) {
      return 'inline';
    }
  }

  function addFingerprint(kind, name, filename, line, column) {
    if (fingerprints.size >= MAX_FINGERPRINTS) return;
    const safeScript = scriptName(filename);
    const safeName = String(name || 'Error').slice(0, 80);
    const safeKind = String(kind || 'error').slice(0, 40);
    const safe = [safeKind, safeName, safeScript, Number(line) || 0, Number(column) || 0].join('|');
    fingerprints.add(hash32(safe));
    scripts.add(safeScript.slice(0, 120));
    errorNames.add(safeName);
    errorKinds.add(safeKind);
    flushToClarity();
  }

  function flushToClarity() {
    if (!fingerprints.size || typeof window.clarity !== 'function') return;
    window.clarity('set', 'serrano_js_error_fp', Array.from(fingerprints));
    window.clarity('set', 'serrano_js_error_count', String(fingerprints.size));
    window.clarity('set', 'serrano_js_error_script', Array.from(scripts));
    window.clarity('set', 'serrano_js_error_name', Array.from(errorNames));
    window.clarity('set', 'serrano_js_error_kind', Array.from(errorKinds));
    if (!eventSent) {
      eventSent = true;
      window.clarity('event', 'serrano_js_error');
    }
  }

  window.addEventListener('error', (event) => {
    if (!event?.message && !event?.error) return;
    addFingerprint(
      'error',
      event.error?.name || 'Error',
      event.filename || event.error?.fileName || '',
      event.lineno || event.error?.lineNumber || 0,
      event.colno || event.error?.columnNumber || 0
    );
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason;
    const stack = typeof reason?.stack === 'string' ? reason.stack : '';
    const scriptMatch = stack.match(/https?:\/\/[^\s)]+/);
    addFingerprint('rejection', reason?.name || 'PromiseRejection', scriptMatch?.[0] || '', 0, 0);
  });

  window.addEventListener('load', flushToClarity, { once: true });
  window.setTimeout(flushToClarity, 3000);

  window.__serranoErrorRum = {
    version: '2026-08-15-v2',
    fingerprints,
    scripts,
    errorNames,
    errorKinds
  };
})();
